// src/models/userFields.js

const userFieldsObj = {
  // ══════════════════════════════════════════════════════════
  // 1) CAMPOS ADMINISTRATIVOS
  // ══════════════════════════════════════════════════════════
  id: {
    label: "ID de Usuario",
    labelEn: "User ID",
    section: "Administrativos",
    default: "",
    inputType: "readonly",
    visibleIn: ["adminUserEdit", "adminUserList"],
    orderList: 1,
  },
  createdAt: {
    label: "Fecha de Creación",
    labelEn: "Creation Date",
    section: "Administrativos",
    default: "",
    inputType: "readonly",
    visibleIn: ["adminUserEdit", "adminUserList"],
    orderList: 2,
  },
  
  // ══════════════════════════════════════════════════════════
  // 2) CORREO (CON CONFIRMACIÓN)
  // ══════════════════════════════════════════════════════════
  correoPropietario: {
    label: "Correo Electrónico",
    labelEn: "Email Address",
    section: "Información del Propietario",
    validation: ["required", "email"],
    default: "",
    inputType: "email",
    placeholder: "ejemplo@correo.com",
    placeholderEn: "example@email.com",
    visibleIn: [
      "adminUserEdit",
      "adminUserList",
      "activar",
      "ligandoSiguiente",
      "consultaDelVeterinario",
    ],
    orderList: 3,
    helperText: "Usaremos este correo para enviarte alertas y notificaciones"
  },

  correoConfirmacion: {
    label: "Confirmar Correo Electrónico",
    labelEn: "Confirm Email",
    section: "Información del Propietario",
    validation: ["required", "email", "match_correo"],
    default: "",
    inputType: "email",
    placeholder: "Escribe tu correo nuevamente",
    placeholderEn: "Type your email again",
    visibleIn: [
      "activar",
      "ligandoSiguiente",
    ],
    orderList: 3.5,
    helperText: "Por favor escribe tu correo nuevamente (no copies y pegues)"
  },

  correoVerificado: {
    label: "Correo Verificado",
    labelEn: "Email Verified",
    section: "Administrativos",
    default: false,
    inputType: "checkbox",
    visibleIn: ["adminUserEdit", "adminUserList"],
    orderList: 4,
  },

  // ══════════════════════════════════════════════════════════
  // 3) DATOS DE PERFIL
  // ══════════════════════════════════════════════════════════
  nombrePropietario: {
    label: "Nombre Completo",
    labelEn: "Full Name",
    section: "Información del Propietario",
    validation: ["required"],
    default: "",
    placeholder: "Ej: Juan Pérez García",
    placeholderEn: "E.g: John Doe",
    inputType: "text",
    visibleIn: ["adminUserEdit", "userEdicion", "activar", "consultaDelVeterinario"],
    orderList: 5,
  },
  
  telefono: {
    label: "Teléfono de Contacto",
    labelEn: "Contact Phone",
    section: "Información del Propietario",
    validation: ["required"],
    default: "",
    placeholder: "Ej: +52 555 123 4567",
    placeholderEn: "E.g: +1 555 123 4567",
    inputType: "tel",
    visibleIn: ["adminUserEdit", "userEdicion", "activar", "consultaDelVeterinario"],
    orderList: 6,
    helperText: "El medio más rápido para contactarte en caso de emergencia"
  },
  
  fechaNacimiento: {
    label: "Fecha de Nacimiento",
    labelEn: "Date of Birth",
    section: "Perfil",
    default: "",
    inputType: "date",
    visibleIn: ["adminUserEdit", "userEdicion"],
    orderList: 7,
  },
  
  urlAvatar: {
    label: "URL de Avatar",
    labelEn: "Avatar URL",
    section: "Perfil",
    default: "",
    placeholder: "Ej: https://...",
    placeholderEn: "E.g: https://...",
    inputType: "text",
    visibleIn: ["adminUserEdit"],
    orderList: 8,
  },
  
  usuarioVerificado: {
    label: "Usuario Verificado",
    labelEn: "User Verified",
    section: "Datos del Usuario",
    default: false,
    inputType: "readonly",
    visibleIn: ["adminEdicion"],
    orderList: 14,
  },
  
  // ══════════════════════════════════════════════════════════
  // 4) MARKETING Y PREFERENCIAS
  // ══════════════════════════════════════════════════════════
  aceptoBoletines: {
    label: "¿Recibir Boletines?",
    labelEn: "Receive Newsletters?",
    section: "Marketing",
    default: false,
    inputType: "checkbox",
    visibleIn: ["userProfileEdit", "adminUserEdit"],
    orderList: 9,
  },
 
  idiomaPreferido: {
    label: "Idioma Preferido",
    labelEn: "Preferred Language",
    section: "Preferencias",
    default: "es",
    inputType: "select",
    options: [
      { value: "es", label: "Español" },
      { value: "en", label: "English" }
    ],
    visibleIn: ["userProfileEdit", "adminUserEdit"],
    orderList: 11,
  },

  timezone: {
    label: "Tu Zona Horaria Actual",
    labelEn: "Your Current Timezone",
    section: "Preferencias",
    default: "America/Mexico_City",
    inputType: "select",
    options: [
      { value: 'America/Mexico_City', label: 'CDMX/Veracruz (UTC-6)' },
      { value: 'America/Cancun', label: 'Cancún/Quintana Roo (UTC-5)' },
      { value: 'America/Tijuana', label: 'Tijuana/Baja California (UTC-8)' },
      { value: 'America/Monterrey', label: 'Monterrey (UTC-6)' },
      { value: 'America/Chihuahua', label: 'Chihuahua (UTC-7)' },
      { value: 'America/Hermosillo', label: 'Hermosillo/Sonora (UTC-7)' },
      { value: 'America/Merida', label: 'Mérida (UTC-6)' },
      { value: 'America/Mazatlan', label: 'Mazatlán (UTC-7)' },
    ],
    visibleIn: ["userEdicion", "adminUserEdit"],
    orderList: 11.5,
    helperText: "Tu zona horaria actual. Cámbiala cuando viajes."
  },

  timezoneProveedores: {
    label: "Zona Horaria de tu Casa",
    labelEn: "Home Timezone",
    section: "Preferencias",
    default: "America/Mexico_City",
    inputType: "select",
    options: [
      { value: 'America/Mexico_City', label: 'CDMX/Veracruz (UTC-6)' },
      { value: 'America/Cancun', label: 'Cancún/Quintana Roo (UTC-5)' },
      { value: 'America/Tijuana', label: 'Tijuana/Baja California (UTC-8)' },
      { value: 'America/Monterrey', label: 'Monterrey (UTC-6)' },
      { value: 'America/Chihuahua', label: 'Chihuahua (UTC-7)' },
      { value: 'America/Hermosillo', label: 'Hermosillo/Sonora (UTC-7)' },
      { value: 'America/Merida', label: 'Mérida (UTC-6)' },
      { value: 'America/Mazatlan', label: 'Mazatlán (UTC-7)' },
    ],
    visibleIn: ["userEdicion", "adminUserEdit"],
    orderList: 11.6,
    helperText: "Zona donde está tu casa y mascota. Solo cámbiala si te mudas."
  },

  // ══════════════════════════════════════════════════════════
  // 5) UBICACIÓN (Selector con combos en cascada)
  // ══════════════════════════════════════════════════════════
  ubicacionCiudad: {
    label: "Tu Ubicación",
    labelEn: "Your Location",
    section: "Preferencias",
    default: "",
    validation: [],  // Solo requerido para mascotas, pero no bloquea otros tipos
    inputType: "ubicacion-selector",
    visibleIn: ["userEdicion", "adminUserEdit", "activar"],
    applicableTypes: ["mascota"],  // ← Solo mostrar en activación de mascotas
    orderList: 11.7,
    helperText: "Selecciona tu ciudad para recibir información del clima en recordatorios de paseos"
  },

  // Estos campos se actualizan automáticamente por el selector
  ubicacionEstado: {
    label: "Tu Estado",
    labelEn: "Your State",
    section: "Preferencias",
    default: "",
     validation: ["required"],
    inputType: "text",
    visibleIn: [], // ← Oculto: se actualiza desde ubicacionCiudad
    orderList: 11.8,
  },

  ubicacionPais: {
    label: "País",
    labelEn: "Country",
    section: "Preferencias",
    default: "MX",
    inputType: "text",
    visibleIn: [], // ← Oculto: se infiere automáticamente
    orderList: 11.9,
  },

  // ══════════════════════════════════════════════════════════
  // 6) DIRECCIÓN PARA PROVEEDORES
  // ══════════════════════════════════════════════════════════
  direccion: {
    label: "Dirección para Proveedores",
    labelEn: "Address for Providers",
    section: "Preferencias",
    default: "",
    inputType: "text",
    placeholder: "Ej: Av. Principal #123, Col. Centro, Veracruz",
    placeholderEn: "E.g: 123 Main St, Downtown, City",
    visibleIn: ["userEdicion", "adminUserEdit"],
    orderList: 11.95,
    helperText: "Dirección que puedes compartir con tus proveedores de servicios"
  },

  genero: {
    label: "Género",
    labelEn: "Gender",
    section: "Perfil",
    default: "",
    inputType: "select",
    options: [
      { value: "hombre", label: "Hombre" },
      { value: "mujer", label: "Mujer" },
      { value: "no quiero decir", label: "Prefiero no decir" }
    ],
    visibleIn: ["userEdicion"],
    orderList: 12,
  },

};

export const USER_FIELDS = userFieldsObj;